






































import VueOptions from '@utils/VueOptions'
import AudienceListingPOILocations from './AudienceListingPOILocations'

settings =
  name: 'AudienceListingMap'

  vue:
    props: ['audienceListing', 'nearbyPOIs']

    components: {
      AudienceListingPOILocations,
    }

    data: ->
      mapOptions:
        draggable: true
        zoomControl: true
        mapTypeControl: false
        scaleControl: false
        streetViewControl: false
        rotateControl: false
        fullscreenControl: false
        disableDefaultUi: true

      mapInfoWindow:
        title: null,
        location: { lat: 0, lng: 0 },
        opened: false

      mapInfoWindowOptions:
        pixelOffset: { width: 0, height: -40 }

    computed:
      poiList: -> @nearbyPOIs?.poi_list || {}
      nearbyPOIMarkers: ->
        markers = []
        for name, poi of @poiList
          for location in poi.locations
            { address, distance, geo_coordinates } = location
            [lat, lng] = geo_coordinates
            marker =
              title: name,
              location: { address, distance, lat, lng }
            marker.logo = { url: poi.logo, scaledSize: { width: 40, height: 40 } } if poi.logo
            markers.push marker
        markers

      mapCenter: ->
        [lng, lat] = @audienceListing.geo_coordinates || []
        { lng, lat }

      zoom: -> 13

      hasLocation: -> @audienceListing?.in_person

    methods:
      hiPOIMarker: (marker) ->
        @mapInfoWindow = marker

      hiCloseInfoWindow: ->
        @mapInfoWindow =
          title: null,
          location: { lat: 0, lng: 0 },
          opened: false

export default VueOptions.vue settings
